import template from './insuranceProfilerSendReportModal.html';
import controller from './insuranceProfilerSendReportModalCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    profilerData: '<',
    familyId: '<',
  },
};
